import { h as __h } from "preact";
/** @import { locationResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {locationResponse} location
 */
export const deleteLocation = async ({
  orgId
}, location) => {
  const res = await confirmModal({
    title: `Delete '${location.name}'?`,
    action: "Delete",
    body: __h("p", {}, "You will not be able to recover this.")
  });
  if (!res) return;
  try {
    await authedApiRequest("DELETE", `/v2/orgs/${orgId}/locations/${location.id}`);
    Query.invalidate([`/v2/orgs/${orgId}/locations`], [`/v2/orgs/${orgId}/locations/${location.id}`], [`/ui/admin/orgs/${orgId}/machines`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};